// Usage: set attribute dx-skip-to-content="selector" on a link
// where selector is jQuery selector of element to skip focus to
angular.
module("dx.webapp.accessibility").
directive("dxSkipToContent", function dxPreventSelectionLossDirective(
	$window
) {
	"use strict";

	return {
		restrict: "A",
		link: link,
	};

	function link($scope, $element, $attrs) {
		$element.on("click", skipToContent);

		$scope.$on("$destroy", function onDestroy() {
			$element.off("click", skipToContent);
		});

		function skipToContent(event) {
			event.preventDefault();
			var skipToContentSelector = $attrs.dxSkipToContent;

			var contentEl = $window.$(skipToContentSelector);
			var addedTabIndex = false;

			// Temporarily add tabindex to make the target element
			// focusable is the tabindex is missing
			if (!contentEl.attr("tabindex")) {
				contentEl.attr("tabindex", "-1");
				addedTabIndex = true;
			}

			contentEl.focus();

			if (addedTabIndex) {
				contentEl.attr("tabindex", null);
			}
		}
	}
});
